import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class OnboardingSourceTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.ONBOARDING_SOURCE;
	override extraClass = TourId.ONBOARDING_SOURCE as string;

	get id(): string {
		return TourId.ONBOARDING_SOURCE;
	}

	override get keyForPersistantDone(): string {
		return OnboardingSourceTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				attachTo: () => {
					return $('#main.step-source .wizard-controls .button');
				},
			},
		];
	}
}
